module.exports = __webpack_public_path__ + "img/cz.eb5bb814.svg";